import { z } from 'zod';
import { sizeSchema, coordinateSchema } from '../../../Shared.js';
import { numberSchema } from '../schemas.js';

const legacyCanvasDrawingItemSchema = z.object({
  kind: z.literal("legacyCanvasDrawing"),
  id: z.string(),
  position: coordinateSchema,
  size: sizeSchema,
  points: z.array(coordinateSchema),
  style: z.object({
    stroke: z.object({
      color: z.string().default("#000"),
      width: numberSchema(1)
    })
  }).nullish().default({ stroke: { color: "#000", width: 1 } })
});

export { legacyCanvasDrawingItemSchema };
//# sourceMappingURL=LegacyCanvasDrawing.js.map
